import ImageLinks from "../assets/Images/ImagesLink";
import { useNavigate } from "react-router-dom";

function AppNavBarWithBackAction({ title }) {
  const navigate = useNavigate();

  const handle_go_back = () => {
    navigate(-1);
  };

  return (
    <div className="flex items-center gap-2" onClick={handle_go_back}>
      <img
        src={ImageLinks.chevron_right}
        className="w-[18px] h-[19px] cursor-pointer"
      />
      <p className="font-custom text-sm font-semibold text-dark_black">
        {title}
      </p>
    </div>
  );
}

export default AppNavBarWithBackAction;
